/**
 * Represents the different products possible to pay for.
 * Inbound shipments and outbound shipments are 2 different products.
 *
 * @deprecated TODO: Find a better name both on the frontend and on the backend.
 */
export enum ProductTypeToPayFor {
  InboundShipment = 'InboundShipment',
}
/**
 * @deprecated TODO: Find a better name both on the frontend and on the backend.
 */
export function isProductTypeToPayFor(value: unknown): value is ProductTypeToPayFor {
  return typeof value === 'string' && Object.keys(ProductTypeToPayFor).includes(value);
}
